<template>
  <div v-if="section" class="row">
    <div class="col-md-12">
      <div class="d-flex justify-content-between mb-3">
        <label class="mr-2">Show Logo</label>
        <b-form-checkbox
          v-model="section.Show"
          switch
        ></b-form-checkbox>
      </div>
    </div>
    <div class="col-md-12">
      <ImageInput v-model="section.Image" label="Link to logo image file" />
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label>Link on clicking the logo</label>
        <input
          v-model="section.Link"
          type="text"
          class="form-control"
          placeholder="example.com"
        />
      </div>
    </div>
    <div class="col-md-6">
      <ColorInput v-model="section.BackgroundColor" label="Background color"/>
    </div>
    <div class="col-md-6">
      <NumberInput v-model="section.MaxWidth" label="Max. width" />
    </div>
    <div class="col-md-6">
      <NumberInput v-model="section.Padding" label="Padding" />
    </div>
    <div class="col-md-12">
      <AlignInput v-model="section.Align" />
    </div>
  </div>
</template>

<script>
import NumberInput from './NumberInput'
import AlignInput from './AlignInput'
import ImageInput from './ImageInput'
import ColorInput from './ColorInput'

export default {
  components: {
    NumberInput,
    AlignInput,
    ImageInput,
    ColorInput,
  },

  props: {
    section: {
      type: [Object],
      default: null,
    },
  },
}
</script>
